import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FilterField } from './filter';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterFieldComponent<T extends FilterField<any>> {
  @Input() filterField: T;
  @Output() filterApplied: EventEmitter<T> = new EventEmitter<T>();

  applyFilter(value: any): void {
    this.filterField.changeValue(value);
    this.filterApplied.emit(this.filterField);
  }
}
